//import controller from './store.controller';
import template from './store.html';

const storeComponent = {
  restrict: 'E',
  bindings: {},
  template,
  //controller
};

export default storeComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/store/store.component.js
 **/